import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { AuthenticatedHeaderComponent } from './authenticated-header/authenticated-header.component';

import { HeaderComponent } from './header.component';
import { UnauthenticatedHeaderComponent } from './unauthenticated-header/unauthenticated-header.component';

@NgModule({
  declarations: [
    HeaderComponent,
    UnauthenticatedHeaderComponent,
    AuthenticatedHeaderComponent
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    HeaderComponent,
    UnauthenticatedHeaderComponent,
    AuthenticatedHeaderComponent
  ],
})
export class HeaderModule { }
